<template>
    <div class="bg_fff">
        <div class="container">
            <div class="bg_fff pt5 pr5 pb5 pl5 width100 box">
                <Breadcrumb :pages="pages">
                    <span slot="append" class="fs14 color_main ml20 underline pointer flright append" @click="$router.back()">返回上一页</span>
                </Breadcrumb>
                <div class="flex jcb">
                    <schedule-list class="width74" :list="scheduleList" :dateArr="dateArray"></schedule-list>
                    <order-rule class="width25"></order-rule>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import ScheduleList from "../../components/appointment/schedule"
  import OrderRule from "../../components/appointment/order-rule"
  import {orderTime} from "../../lib/cache/OrderTime";
  import {timeFormat} from "../../lib/utils";
  import dayjs from 'dayjs';
  import 'dayjs/locale/zh-cn'
  import Breadcrumb from "../../components/common/Breadcrumb"

  export default {
    name: "DepartmentSchedule",
    data() {
      return {
        form: {},
        orderInfo: {},
        scheduleList: [],
          pages:[],//存放页面导航
          dateArray:[]//存放日期数组
      }
    },
    computed: {},
    components: {ScheduleList, OrderRule,Breadcrumb},
    mixins: [],
    created() {
      this.orderInfo = orderTime.get()
        this.pages = [this.orderInfo.hosName,this.orderInfo.deptName];//页面导航
    },
    mounted() {
        this.getDate();//获取后期天时间字符串数组
        this.getSchedule();//获取排班

    },
    methods: {
      async getSchedule() {
        const {code, list} = await this.$http('smarthos.yygh.ApiDoctorService.pblist', {
          hosId: this.orderInfo.hosId,
          deptId: this.orderInfo.deptId,
          ispb: 0,
          date: ''
        })
        if(code==0) this.pbInfoF(list)

      },
      async pbInfoF(list) {

        for (const o of list){
            const deptSchemeList = o.deptSchemeList[0] || {};
            const schemeList = deptSchemeList.schemeList || [];
            const info = {};
            const pbInfo = ['上午','下午'].map((r,index)=>{
                return {
                    date:r,//上午还是下午
                    list:[...this.dateArray].map(date => {
                            date.hyinfo = schemeList.filter(
                                sche => {
                                  return  sche.ampm == index + 1 && date.schdate == sche.schdate
                                }
                            )
                        return { ...date }
                        }
                    )
                }
            });
            info.docName = o.ysid=='0'?'普通号':o.ysxm;
            info.skill = o.ysjs;
            info.title = o.yszc;
            info.pbList = pbInfo;
            this.scheduleList.push(info);
        }

      },
      getDate() {
        for(let i = 0;i < 7; i++){
            this.dateArray.push({
                schdate:dayjs().add(i + 1,"day").format('YYYYMMDD'),//时间格式 明天开始
                week:dayjs().add(i + 1,"day").locale("zh-cn").format('dddd'),
                date:dayjs().add(i + 1, "day").format("MM/DD")
            })
        }
      },
    }
  }
</script>

<style scoped lang="scss">
    .container {
        background-color: #f0f0f0;
        padding: 10px;
        margin: 0 auto;
    }

    .box {
        margin: 0 auto;
    }

    .underline {
        text-decoration: underline;
    }

    .flright{
        float: right;
    }

    .border_under{
        border-bottom: 1px solid #E8E8E8;
    }
    .append{
        position: absolute;
        right: 0;
    }
</style>